import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import {licenses} from '../constants/licenses';
import * as constants from '../constants/system-setup-constants';

import type {List} from 'immutable';
import type {ActionsMap} from 'redux-store';

/*
 * to generate a new license file:
 * run 'npm run get-licenses' for each package file.
 * concatenate all raw license files into a JSON array of license files
 * import JSON file here as 'rawLicenses'
 * import {getLibrariesFromRawJsonList} from '../helpers/library-helpers'
 * const licenses = getLibrariesFromRawJsonList(rawLicenses)
 */

export type SSLibrariesStore = {
    libraries: List<unknown>;
};

const initialState = (): SSLibrariesStore => {
    return {
        libraries: Immutable.List(),
    };
};

const actionsMap: ActionsMap<SSLibrariesStore> = {
    [constants.SS_LIBRARIES_SUCCESS]: () => {
        return {
            libraries: licenses,
        };
    },

    [constants.DISPOSE_SS_LIBRARIES_STORE]: () => {
        return initialState();
    },
};

export default createReducer<SSLibrariesStore>(initialState(), actionsMap);
